import { render, staticRenderFns } from "./cardMsg.vue?vue&type=template&id=6f5b5a2e&"
import script from "./cardMsg.vue?vue&type=script&lang=js&"
export * from "./cardMsg.vue?vue&type=script&lang=js&"
import style0 from "./cardMsg.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports